// @flow

export const screenConstants = {
  home: 'HOME',
  companies: 'COMPANIES',
  accountManagers: 'ACCOUNT MANAGERS',
  clients: 'CLIENTS'
}

export const actionTypes = {
  GET_COMPANIES: 'Admin/GET_COMPANIES',
  GET_COMPANIES_REQUEST: 'Admin/GET_COMPANIES_REQUEST',
  GET_COMPANIES_SUCCESS: 'Admin/GET_COMPANIES_SUCCESS',
  GET_COMPANIES_FAILURE: 'Admin/GET_COMPANIES_FAILURE',

  GET_COMPANIES_SUGGESTION: 'Admin/GET_COMPANIES_SUGGESTION',
  GET_COMPANIES_SUGGESTION_REQUEST: 'Admin/GET_COMPANIES_SUGGESTION_REQUEST',
  GET_COMPANIES_SUGGESTION_SUCCESS: 'Admin/GET_COMPANIES_SUGGESTION_SUCCESS',
  GET_COMPANIES_SUGGESTION_FAILURE: 'Admin/GET_COMPANIES_SUGGESTION_FAILURE',

  GET_ACCOUNT_MANAGERS: 'Admin/GET_ACCOUNT_MANAGERS',
  GET_ACCOUNT_MANAGERS_REQUEST: 'Admin/GET_ACCOUNT_MANAGERS_REQUEST',
  GET_ACCOUNT_MANAGERS_SUCCESS: 'Admin/GET_ACCOUNT_MANAGERS_SUCCESS',
  GET_ACCOUNT_MANAGERS_FAILURE: 'Admin/GET_ACCOUNT_MANAGERS_FAILURE',

  GET_ROLES: 'Admin/GET_ROLES',
  GET_ROLES_SUCCESS: 'Admin/GET_ROLES_SUCCESS',

  GET_ACCOUNT_MANAGERS_SUGGESTION: 'Admin/GET_ACCOUNT_MANAGERS_SUGGESTION',
  GET_ACCOUNT_MANAGERS_SUGGESTION_REQUEST:
    'Admin/GET_ACCOUNT_MANAGERS_SUGGESTION_REQUEST',
  GET_ACCOUNT_MANAGERS_SUGGESTION_SUCCESS:
    'Admin/GET_ACCOUNT_MANAGERS_SUGGESTION_SUCCESS',
  GET_ACCOUNT_MANAGERS_SUGGESTION_FAILURE:
    'Admin/GET_ACCOUNT_MANAGERS_SUGGESTION_FAILURE',

  ADD_OR_UPDATE_AM: 'Admin/ADD_OR_UPDATE_AM',
  ADD_OR_UPDATE_AM_REQUEST: 'Admin/ADD_OR_UPDATE_AM_REQUEST',
  ADD_OR_UPDATE_AM_SUCCESS: 'Admin/ADD_OR_UPDATE_AM_SUCCESS',
  ADD_OR_UPDATE_AM_FAILURE: 'Admin/ADD_OR_UPDATE_AM_FAILURE',

  ADD_OR_UPDATE_COMPANY: 'Admin/ADD_OR_UPDATE_COMPANY',
  ADD_OR_UPDATE_COMPANY_REQUEST: 'Admin/ADD_OR_UPDATE_COMPANY_REQUEST',
  ADD_OR_UPDATE_COMPANY_SUCCESS: 'Admin/ADD_OR_UPDATE_COMPANY_SUCCESS',
  ADD_OR_UPDATE_COMPANY_FAILURE: 'Admin/ADD_OR_UPDATE_COMPANY_FAILURE',

  GET_CLIENTS: 'Admin/GET_CLIENTS',
  GET_CLIENTS_REQUEST: 'Admin/GET_CLIENTS_REQUEST',
  GET_CLIENTS_SUCCESS: 'Admin/GET_CLIENTS_SUCCESS',
  GET_CLIENTS_FAILURE: 'Admin/GET_CLIENTS_FAILURE',

  INVITE_NEW_CLIENT: 'Admin/INVITE_NEW_CLIENT',
  INVITE_NEW_CLIENT_REQUEST: 'Admin/INVITE_NEW_CLIENT_REQUEST',
  INVITE_NEW_CLIENT_SUCCESS: 'Admin/INVITE_NEW_CLIENT_SUCCESS',
  INVITE_NEW_CLIENT_FAILURE: 'Admin/INVITE_NEW_CLIENT_FAILURE',

  GET_COMPANY_PROFILE: 'Admin/GET_COMPANY_PROFILE',
  GET_COMPANY_PROFILE_REQUEST: 'Admin/GET_COMPANY_PROFILE_REQUEST',
  GET_COMPANY_PROFILE_SUCCESS: 'Admin/GET_COMPANY_PROFILE_SUCCESS',
  GET_COMPANY_PROFILE_FAILURE: 'Admin/INVITE_NEW_CLIENT_FAILURE'
}
